import { Injectable } from '@angular/core';
import { Ad } from '../model/ad';
import { environment } from '@environments/environment';
import { EventConfiguration } from '../interfaces/analytics.interface';

declare function setupPiwikTracker(category);
declare function trackPiwikAction(category, action, name, value);

@Injectable()
export class TrackingService {

  public static readonly kActionMain                 = 'Main App';
  public static readonly kActionGoToScene            = 'GoTo Scene';
  public static readonly kActionBeaconScene          = 'Beacon Scene';
  public static readonly kActionCommunity            = 'Community';
  public static readonly kActionAbout                = 'About Home';
  public static readonly kActionRatings              = 'Ratings';
  public static readonly kActionContact              = 'Contact';  // done
  public static readonly kActionWishList             = 'Wishlist';
  public static readonly kActionSocial               = 'Social';
  public static readonly kActionVideoQuality         = 'Video Quality (change)';
  public static readonly kActionVideoFullScreen      = 'Full Frame Video';
  public static readonly kActionVideoFloorplan       = 'Floorplan Video';
  public static readonly kActionVideo3D              = '3D Video';
  public static readonly kActionCrosslink            = 'Crosslink';
  public static readonly kActionViewOptions          = 'View Options';
  public static readonly kActionViewOptionDetail     = 'View Option Detail';
  public static readonly kActionWishlistOption       = 'Wishlist Option';

  public static readonly kActionAdDisplayed          = 'Advertiser (image/%)';  // done
  public static readonly kActionAdVideoPlayed        = 'Advertiser (video/%)';  // done
  public static readonly kActionHighlightVideo       = 'Highlight Video';

  public static readonly kActionWishlistEmail        = 'Wishlist (email)';
  public static readonly kActionFeedbackEmail        = 'Feedback (email)';

  public static readonly kActionAdShownGroup         = 'Ad shown (option group level)';
  public static readonly kActionAdShownOption        = 'Ad shown (specific option)';
  public static readonly kActionAdPlayedGroup        = 'Ad Video Played (option group level)';
  public static readonly kActionAdPlayedOption       = 'Ad Video played (option specific level)';

  public static readonly rePattern = /%/;
  private category: string;

  constructor() { }

  configurePiwik(builderDir: string, modelDir: string) {
    this.category = builderDir + '/' + modelDir;
    setupPiwikTracker(this.category);
    this.initAnalytics();
  }

  trackAction(action: string, name: string, value: number) {
    trackPiwikAction(this.category, action, name, value);
    // send to GA
    this.sendEvent({
      eventCategory: this.category,
      eventAction: action,
      eventLabel: name,
      eventValue: String(value)
    });
  }

  trackAdVideoPlayback(ad: Ad, parentName: string) {
    const action = TrackingService.kActionAdVideoPlayed.replace(TrackingService.rePattern, parentName);
    this.trackAction(action, ad.displayName, null);
  }

  trackAdImpression(ad: Ad, parentName: string) {
    const action = TrackingService.kActionAdDisplayed.replace(TrackingService.rePattern, parentName);
    this.trackAction(action, ad.displayName, null);
  }

  initAnalytics() {
    (<any>window).ga('create', environment.googleAnalytics, 'auto');
  }

  sendEvent(eventConfig: EventConfiguration, trackerSettings?: object): void {
    if (trackerSettings) { this.setFieldsOnTrackerForSession(trackerSettings); }
    const configuration = { hitType: 'event', ...eventConfig };
    (<any>window).ga('send', configuration);
  }
  /**
   * Sets key value pairs on tracker for the remainder of the session
   * @param trackerSettings All key/value pairs set on the GA
   */
  setFieldsOnTrackerForSession(trackerSettings: object): void {
    for (const key in trackerSettings) {
      if (trackerSettings[key] !== undefined) {
        (<any>window).ga('set', key, trackerSettings[key]);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tracking.service.ts